module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Dashboard.817eb6f3.svg";